var _defs, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 282 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M37.167 264.296l-.766-.642L200.954 67.546l.767.643zM74.915 233.311l-.766-.643L238.703 36.561l.766.643z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.28,
    cy: 97.845,
    r: 55.5,
    transform: "rotate(-140 187.28 97.845)",
    stroke: "#DEB06A"
  })));
}

var MemoSvgContactIllustration = /*#__PURE__*/React.memo(SvgContactIllustration);
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI4MiAzMDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjM3LjE2NjUiIHk9IjI2NC4yOTYiIHdpZHRoPSIxIiBoZWlnaHQ9IjI1NiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE0MCAzNy4xNjY1IDI2NC4yOTYpIiBmaWxsPSIjMTQxNDE0Ii8+CjxyZWN0IHg9Ijc0LjkxNSIgeT0iMjMzLjMxMSIgd2lkdGg9IjEiIGhlaWdodD0iMjU2IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTQwIDc0LjkxNSAyMzMuMzExKSIgZmlsbD0iIzE0MTQxNCIvPgo8Y2lyY2xlIGN4PSIxODcuMjgiIGN5PSI5Ny44NDUyIiByPSI1NS41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTQwIDE4Ny4yOCA5Ny44NDUyKSIgc3Ryb2tlPSIjREVCMDZBIi8+Cjwvc3ZnPgo=";
export { MemoSvgContactIllustration as ReactComponent };